import { useEffect, useState } from 'react';
import { BiChevronDown, BiChevronUp } from 'react-icons/bi';

import { CloseIcon } from '../../../../../assets/icons/CloseIcon';
import { ErrorIcon } from '../../../../../assets/icons/ErrorIcon';
import { apiSensedia } from '../../../../../services/api-sensedia';
import { delay } from '../../../../../utils/delay';
import { ButtonSubmit } from './ButtonSubimit';
import { TableModal } from './TableModal';
import { TableModalEquipeDistribuicao } from './TableModalEquipeDistribuicao';
import { Toast } from './Toast';

export const ModalDistribuicao = ({ onClose, data, disponiveis }: any) => {
  const [sellers, setSellers] = useState(data);

  const [leadsToTransfer, setLeadsToTransfer] = useState(0);

  const [dropdownSelected, setDropdownSelected] = useState(false);

  const [loadingDistribuicao, setLoadingDistribuicao] = useState(false);
  const [specificSellers, setSpecificSellers] = useState(false);
  const [specificTeams, setSpecificTeams] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [messageToast, setMessageToast] = useState('');
  const [typeMessage, setTypeMessage] = useState<
    'error' | 'warn' | 'success' | ''
  >('');

  const [alertBox, setAlertBox] = useState(false);
  const [alertBoxText, setAlertBoxText] = useState('');
  const [conditionDisableButton, setConditionDisableButton] = useState(true);
  const [selectedOption, setSelectedOption] = useState(null);

  const [inputValues, setInputValues] = useState([]);
  const [payloadForDistribution, setPayloadForDistribution] = useState([]);

  const hasChecked = selectedOption !== null;

  const shippingTemplates = [
    {
      label: 'Distribuir leads para todos os vendedores 1/1',
      value: 'todos-vendedores'
    },
    { label: 'Distribuir leads para todas as equipes', value: 'todas-equipes' },
    // {
    //   label: 'Distribuir leads para equipes específicas',
    //   value: 'selecionar-equipes'
    // },
    {
      label: 'Distribuir leads para vendedores específicos',
      value: 'vendedores-especificos'
    }
  ];

  const handleDistributionType = async () => {
    setLoadingDistribuicao(true);
    const optionSelected = await shippingTemplates[selectedOption].value;
    if (optionSelected === 'vendedores-especificos') {
      await handleDistribuicao();
    } else if (optionSelected === 'todas-equipes') {
      await handleDistribuicaoAutomaticaEquipes();
    } else {
      await handleDistribuirAutomatico();
    }
    setLoadingDistribuicao(false);
  };

  const handleDistribuicao = async () => {
    if (leadsToTransfer === 0) {
      handleShowToast(
        'open',
        'Digite uma quantidade de leads para distribuir',
        'warn'
      );
      return;
    }
    try {
      const distribuicoes = [...payloadForDistribution];

      for await (const distribuicao of distribuicoes) {
        await apiSensedia.put(
          '/oportunidades-sulamerica/painel-leads/distribuicoes',
          distribuicao,
          {
            timeout: 0
          }
        );
      }

      await handleShowToast(
        'open',
        'Distribuição de leads iniciada, por favor acompanhe atualizando a tela de gestão até que a quantidade seja distribuída',
        'success'
      );
    } catch (err: any) {
      setTypeMessage('error');

      handleShowToast(
        'open',
        `Ocorreu um erro em alguma distribuição: ${err?.message}`,
        'error'
      );
    }
  };

  const handleDistribuicaoAutomaticaEquipes = async () => {
    const limit = 20;
    const offset = 0;
    try {
      const { data } = await apiSensedia.get(
        `/oportunidades-sulamerica/painel-leads/equipes/lista-redistribuicao`,
        {
          timeout: 0
        }
      );

      if (data?.length <= 0) {
        handleShowToast(
          'open',
          'Você não possui equipes cadastradas ou ativas. Crie ou ative as suas equipes através do menu.',
          'warn'
        );
        return;
      }

      handleShowToast(
        'open',
        'Seus leads estão sendo distribuidos, favor aguarde! poderá levar alguns segundos',
        'warn'
      );
      let count = 1;

      while (count !== 0) {
        const { data } = await apiSensedia.put(
          '/oportunidades-sulamerica/painel-leads/distribuicoes/automatica-equipes',
          undefined,
          {
            timeout: 0,
            params: { limit, offset }
          }
        );
        count = data?.total_leads || 0;
      }
      await handleShowToast(
        'open',
        'Distribuição de leads iniciada, por favor acompanhe atualizando a tela de gestão até que a quantidade seja distribuída',
        'success'
      );
    } catch (err) {
      await setTypeMessage('error');
      handleShowToast(
        'open',
        'Ocorreu um erro, favor tente novamente',
        'error'
      );
      console.log(err);
    }
  };

  const handleDistribuirAutomatico = async () => {
    const limit = 20;
    let offset = 0;

    let count = 200;
    try {
      while (count > 0) {
        const { data } = await apiSensedia.put(
          '/oportunidades-sulamerica/painel-leads/distribuicoes/automatica',
          undefined,
          {
            timeout: 0,
            params: { limit, offset }
          }
        );
        count = data.total_leads;
        offset = data.last_user;
      }
      await handleShowToast(
        'open',
        'Distribuição de leads iniciada, por favor acompanhe atualizando a tela de gestão até que a quantidade seja distribuída',
        'success'
      );
    } catch (err) {
      handleShowToast(
        'open',
        'Ocorreu um erro, favor tente novamente',
        'error'
      );

      console.log(err);
    }
  };

  const sumLeadsNaCarteira = (obj) =>
    Object.entries(obj).reduce((sum, [key, value]) => {
      if (key === 'concluidos') return 0;
      if (Array.isArray(value)) {
        return sum + value.length;
      } else if (typeof value === 'object') {
        return sum + sumLeadsNaCarteira(value);
      }
      return sum;
    }, 0);

  const handleShowToast = async (
    action: 'open' | 'close',
    message?: string,
    type?: 'error' | 'warn' | 'success'
  ) => {
    if (action === 'open') {
      await setMessageToast(message);
      await setTypeMessage(type);
      setShowToast(true);
      setTimeout(() => {
        setShowToast(false);
        if (type === 'success') {
          onClose();
          window.location.reload();
          onClose();
        }
      }, 5000);
    } else {
      setShowToast(false);
    }
  };

  const handleRadioChange = (index) => {
    const inputChecked = shippingTemplates[index].value;

    if (inputChecked === 'vendedores-especificos') {
      setSpecificSellers(true);
    } else if (inputChecked === 'selecionar-equipes') {
      setSpecificTeams(true);
    } else {
      setSpecificSellers(false);
      setDropdownSelected(false);
      setConditionDisableButton(false);
      setAlertBox(false);
    }

    setSelectedOption(index);
  };

  const handleChangeSeller = (seller: any) => {
    setConditionDisableButton(false);
  };

  const handleLeadsToTransfer = (value: number, id: any) => {
    const parseIntDisp = parseInt(disponiveis);

    // const objNumberOfLeads = {};
    // let numberOfLeads;

    // Object.keys(id.leads_usuario).forEach((prop) => {
    //   objNumberOfLeads[prop] = id.leads_usuario[prop].length;
    //   numberOfLeads = id.leads_usuario[prop].length;
    // });

    if (parseIntDisp === 0) {
      setAlertBox(true);
      setAlertBoxText(`Não existem Leads para serem distribuídas`);
    } else if (value > parseIntDisp) {
      setAlertBox(true);
      setAlertBoxText(
        `A soma total de Leads deve ser no máximo de ${parseIntDisp}`
      );
    } else {
      setLeadsToTransfer(value);
      setAlertBox(false);
    }
  };

  const handleValueChange = (newValue: string, id: number) => {
    const parseIntDisp = parseInt(disponiveis);
    const parsedValue = parseInt(newValue, 10);

    const newInputValues = [...inputValues];
    newInputValues[id] = parsedValue;

    const sum = newInputValues.reduce((acc, currentValue) => {
      const numValue = currentValue !== undefined ? currentValue : 0;
      return acc + numValue;
    }, 0);

    setInputValues(newInputValues);
    handleLeadsToTransfer(sum, sellers[id]);

    let payload = {};

    payload = {
      id_vendedor: sellers[id].id,
      quantidade: parsedValue
    };

    const newPayload =
      parsedValue <= parseIntDisp
        ? [...payloadForDistribution, payload]
        : payloadForDistribution;

    const uniqueMap = new Map();

    for (const obj of newPayload) {
      uniqueMap.set(obj.id_vendedor, obj);
    }

    const finalPayload = Array.from(uniqueMap.values());

    setPayloadForDistribution(finalPayload);
  };

  const handleConditionDisableButton = () => {
    const inputChecked = shippingTemplates[selectedOption]?.value;

    if (inputChecked === 'vendedores-especificos' || leadsToTransfer !== 0) {
      setConditionDisableButton(!hasChecked || specificSellers);
    }
  };

  const handleClearInputValue = () => {
    setInputValues([]);
  };

  const objForDistributionInput = {
    inputValues,
    handleClearInputValue,
    handleValueChange
  };

  useEffect(() => {
    handleConditionDisableButton();
  }, [selectedOption]);

  useEffect(() => {
    const sortVendedores = sellers.sort((a, b) => {
      if (a.nome < b.nome) {
        return -1;
      }
      if (a.nome > b.nome) {
        return 1;
      }
      return 0;
    });

    const vendedoresAtivos = sortVendedores.filter(
      (vendedor: any) =>
        vendedor.status === 'ativo' && vendedor.tipo !== 'gestor'
    );
    setSellers(vendedoresAtivos);
    setTypeMessage('');
  }, [data]);

  return (
    <>
      <div className="tw-fixed tw-inset-0 tw-z-50 tw-bg-white md:tw-bg-black md:tw-opacity-30"></div>
      <div className="tw-absolute tw-w-full md:tw-w-auto tw-inset-y-0 tw-right-0 tw-bg-[#ffffff] md:tw-rounded-l-[25px] tw-z-50">
        <div className="tw-px-[16px] tw-py-[20px] md:tw-p-[30px] tw-flex tw-justify-between">
          <h2 className="tw-text-[1.25rem] md:tw-text-[1.5rem] tw-leading-[2rem] tw-font-bold">
            Distribuição manual de leads
          </h2>
          <button onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <hr className="tw-bg-[#D2D2D2] tw-h-[1px] tw-mb-[20px]" />
        <div className="tw-flex tw-justify-between tw-mx-[16px]  md:tw-mx-[30px] tw-py-[20px] tw-px-[20px] md:tw-px-[40px] tw-rounded-[20px] tw-bg-[#F4F4F4]">
          <div className="tw-text-center">
            <p className="tw-whitespace-nowrap tw-min-w-[50%] md:tw-min-w-[150px]">
              Total de Vendedores:
            </p>
            <span className="tw-text-[2.5rem] tw-font-bold">
              {sellers.length}
            </span>
          </div>
          <div className="tw-bg-[#D2D2D2] tw-w-[1px] tw-ml-[20px] tw-mr-[30px] tw-text-transparent">
            div
          </div>
          <div className="tw-text-center ">
            <p className="tw-whitespace-nowrap tw-min-w-[50%] md:tw-min-w-[150px]">
              Total de Leads:
            </p>
            <span className="tw-text-[2.5rem] tw-font-bold">{disponiveis}</span>
          </div>
        </div>
        <div className="tw-flex tw-flex-col tw-gap-[20px] tw-p-[30px]">
          <button
            className="tw-w-full tw-text-[#FFFFFF] tw-py-[13px] tw-rounded-[134px] tw-bg-[#001E64]"
            onClick={() => (window.location.href = '/corretor/leads/perfis')}
          >
            Cadastrar novo vendedor
          </button>
          <button
            className="tw-w-full tw-text-[#FFFFFF] tw-py-[13px] tw-rounded-[134px] tw-bg-[#2A4E9A]"
            onClick={() =>
              (window.location.href = '/corretor/leads/configuracoes')
            }
          >
            Configurações
          </button>
        </div>
        <hr className="tw-bg-[#D2D2D2] tw-h-[1px] tw-mb-[20px]" />
        <h2 className="tw-font-bold tw-text-[1.25rem] tw-leading-[2rem] tw-px-[30px]">
          Selecione um modelo de envio:
        </h2>
        <div className="tw-px-[30px] tw-bg-[#FFFFFF] tw-py-[20px] md:tw-rounded-bl-[20px]">
          {shippingTemplates.map((item, index) => {
            return (
              <div
                key={index}
                className={`tw-flex tw-items-center tw-gap-[5px] tw-text-[#001E64] tw-py-2`}
              >
                <input
                  type="radio"
                  name="distribuicao"
                  // checked={}
                  onChange={() => handleRadioChange(index)}
                />
                <label>{item.label}</label>
              </div>
            );
          })}
          {specificSellers && (
            <div className="tw-w-full tw-mt-[10px]">
              <button
                className="tw-text-[#323232] tw-flex tw-items-center tw-justify-between tw-bg-[#FFFFFF] tw-w-full tw-p-[16px] tw-rounded-md tw-border-[1px] tw-border-[#D4D7DE] tw-focus:outline-none tw-focus:shadow-outline"
                onClick={() => {
                  dropdownSelected && setConditionDisableButton(true);

                  setDropdownSelected(!dropdownSelected);
                  alertBox && setAlertBox(false);
                }}
              >
                <span className="tw-text-start tw-overflow-hidden tw-whitespace-nowrap tw-text-ellipsis tw-max-w-[280px]">
                  Selecionar Vendedores
                </span>
                {dropdownSelected ? (
                  <BiChevronUp className="tw-w-[24px] tw-h-[24px]" />
                ) : (
                  <BiChevronDown className="tw-w-[24px] tw-h-[24px]" />
                )}
              </button>
            </div>
          )}
          {specificSellers && dropdownSelected && (
            <TableModal
              data={sellers}
              identification={'distribuicao'}
              handleChangeSeller={handleChangeSeller}
              objForDistributionInput={objForDistributionInput}
            />
          )}

          {specificTeams && (
            <TableModalEquipeDistribuicao
              handleShowToast={handleShowToast}
              disponiveis={disponiveis}
            />
          )}
          {alertBox && (
            <div
              className={`tw-bg-[#FACED2] tw-mt-[20px] tw-flex tw-justify-center tw-items-center tw-gap-[10px] tw-px-[16px] md:tw-px-[20px] tw-py-[16px] tw-rounded-[12px] tw-shadow-lg`}
            >
              <span>
                <ErrorIcon />
              </span>
              {alertBoxText}
            </div>
          )}

          {!specificTeams && (
            <div
              className={`${
                specificSellers ? 'tw-mt-[24px]' : 'tw-mt-[30px] md:tw-mt-0'
              }`}
            >
              <ButtonSubmit
                loading={loadingDistribuicao}
                condition={alertBox ? alertBox : conditionDisableButton}
                label=" Distribuir"
                onSubmit={() => handleDistributionType()}
              />
            </div>
          )}
          <button
            className="md:tw-hidden tw-mt-[20px] tw-bg-[#FFFFFF] tw-border-[#001E64] tw-border-[1px] tw-w-full tw-text-[#001E64] tw-py-[11px] tw-rounded-[134px]"
            onClick={onClose}
          >
            Voltar
          </button>

          {showToast && (
            <Toast
              typeMessage={typeMessage}
              message={messageToast}
              onClose={handleShowToast}
            />
          )}
        </div>
      </div>
    </>
  );
};
